import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router';

import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { setAppNavigate } from '@/shared/services/helpers/navigate-helper';
import { MainLoader } from '@/shared/ui';
import { WebViewBridgeProvider } from '@/shared/webview';
import { useAppSelector } from '@/store';

import { LanguageGuard } from './language.guard';

const AppProvider: React.FC = () => {
  const { navigate } = useAppNavigate();
  const { headerConfig, isLoading } = useAppSelector((state) => state.app);

  setAppNavigate(navigate);

  useEffect(() => {
    document.title = `Nomad ${headerConfig.helmetTitle ? `/ ${headerConfig.helmetTitle}` : ''}`;
  }, [headerConfig]);

  return (
    <LanguageGuard>
      <Helmet titleTemplate="Nomad / %s" defaultTitle="Nomad">
        <title>{headerConfig.helmetTitle}</title>
      </Helmet>
      {isLoading > 0 && <MainLoader fullScreen />}
      <WebViewBridgeProvider>
        <Outlet />
      </WebViewBridgeProvider>
    </LanguageGuard>
  );
};

export default AppProvider;
